export default __webpack_public_path__ + "static/media/avatar21-alien.c19de322.png";